import { getWebsiteLanguage } from './get-website-language';

const PHONE_PREFIX_MAP: Record<string, string> = {
  ro: '+40',
  pl: '+48',
};

const PHONE_PLACEHOLDER_MAP: Record<string, string> = {
  ro: '___ ___ ___',
  pl: '_ _ _  _ _ _  _ _ _',
};

/**
 * Returns the phone prefix based on the website's country/language
 */
export function getPhoneCountryPrefix(): string {
  const language = getWebsiteLanguage();
  return PHONE_PREFIX_MAP[language];
}

/**
 * Returns the phone placeholder pattern based on the website's country/language
 */
export function getPhonePlaceholder(): string {
  const language = getWebsiteLanguage();
  return PHONE_PLACEHOLDER_MAP[language] || '___ ___ ___';
}
